export const PUBLICATION_CONSTS = {
  anotherUserEditThisPublication: 'Сейчас публикацию редактирует пользователь',
  clickOnEditButton: 'Вы можете принудительно выбросить его из редактора, если нажмете на кнопку "Редактировать"',
  secondText: '(Если автор не сохранил свои изменения, он может потерять их)',
  edit: 'Редактировать',
  goBackToPublicationList: 'Вернуться к списку публикаций'
}
